module.exports = "<mat-toolbar class=\"antrag-footer\">UBG 2019</mat-toolbar>"